import { AlertServiceProvider } from '../../../core/services/alert-service/alert-service';
import { AuthenticationServiceProvider } from '../../../core/services/authentication-service/authentication-service';
import { Component, OnInit } from '@angular/core';
import { FormField } from '../../../../submodules/sellions_forms/projects/forms/src/lib/interfaces/form-field.interface';
import { FormGroup } from '@angular/forms';
import { IonicPage, NavParams, ViewController } from 'ionic-angular';
import { take } from 'rxjs/operators';
import { TextServiceProvider } from '../../../core/services/text-service/text-service';
import { UserTask } from '../../interfaces/user-task.interface';
import { UserTaskService } from '../../services/user-task.service/user-task.service';
import { ENVIRONMENT } from '../../../../../environments/environment';

@IonicPage()
@Component({
  selector: 'page-user-task-preview',
  templateUrl: 'user-task-preview.html',
})
export class UserTaskPreviewPage implements OnInit {
  public disabled: boolean;
  public userTask: UserTask;
  public dataViewBaseAPI = ENVIRONMENT.engineUrl;
  public form: FormField[];
  public json: any;
  public taskType: 'new' | 'assigned' | 'closed';
  public valid: boolean = false;

  constructor(
    public authService: AuthenticationServiceProvider,
    public textService: TextServiceProvider,
    private alertService: AlertServiceProvider,
    private navParams: NavParams,
    private userTaskService: UserTaskService,
    private viewCtrl: ViewController,
  ) {
    this.userTask = this.navParams.get('userTask');
    this.disabled = this.navParams.get('disabled');
    this.taskType = this.navParams.get('taskType');
  }

  public ngOnInit() {
    this.getUserTask(this.userTask.number);
  }

  public formChangeUpdate(form: FormGroup) {
    this.json = JSON.parse(JSON.stringify(form.getRawValue()));
    this.valid = form.valid;
  }

  public getUserTask(id: string) {
    this.userTaskService
      .get(id)
      .pipe(take(1))
      .subscribe((userTask: UserTask) => {
        this.userTask = userTask;
        this.form = this.getForm(userTask);
      });
  }

  private getForm(task: UserTask): FormField[] {
    const form = JSON.parse(this.userTask.form) as FormField[];
    return form.map((field) => ({ ...field, predefinedValue: task.variables && task.variables[field.id] }));
  }

  public save() {
    this.disabled = true;
    this.userTaskService
      .complete(this.userTask.number, this.json)
      .pipe(take(1))
      .subscribe(
        () => {
          this.getUserTask(this.userTask.number);
          this.taskType = 'closed';
        },
        (error) => {
          this.alertService.showErrorAlert('Niestety nie udało się zrealizować zadania. ' + error.error, 'Bląd');
          this.disabled = false;
        },
      );
  }

  public assign() {
    this.userTaskService
      .claim(this.userTask.number)
      .pipe(take(1))
      .subscribe(
        () => {
          this.getUserTask(this.userTask.number);
          this.taskType = 'assigned';
          this.disabled = false;
        },
        (error) => this.alertService.showErrorAlert('Niestety nie udało się przypisać zadania. ' + error.error, 'Bląd'),
      );
  }

  public close() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/modules/user-tasks/pages/user-task-preview/user-task-preview.ts